export const getEnvVarValue = (key, env) => {
    const value = env?.[key];
    if (value == null) {
        throw new Error(`Environment Variable not found for key: ${key}`);
    }
    return value;
};
export const isDebug = (env) => env?.DEBUG === 'true';
export const isProdEnv = (env) => ['prod', 'production'].includes(env?.NODE_ENV);
export const isProdDeploy = (env) => [env?.DEPLOYMENT, env?.VITE_DEPLOYMENT, env?.DEPLOYMENT_ENVIRONMENT].includes('production');
//# sourceMappingURL=index.js.map